import React,{useState,useEffect} from 'react';
import WhatsAppButton from './whatsapp';
import Header from './Header';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import {Link} from 'react-router-dom';
import Chat from './chat';
import {Helmet} from 'react-helmet';
import Footer from './Footer';
import Call from './call';
import Marquee from './marquee';


const CityBase=()=>{

    const [question,setquestion]=useState([]);
     const [previous,setprevious]=useState([]);
     
 const [cat,setcatsubcat]=useState([]);
    const [cats,setcatsubcats]=useState([]);
    const[city,setcity]=useState([]);
   const [activetab,setactivetab]=useState(0);


     useEffect(()=>{
    const fetchTestimonial=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/news`);
     setquestion(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchprevious=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/pcost`);
     setprevious(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetcatsubcat=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/designideasall`);
    
     setcatsubcat(res.data.category);
    setcatsubcats(res.data.subcategory);
      }catch(error){
      console.error(error);
      }
    }

    const cityu=async()=>{
         try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/cityproject`);
   
     setcity(res.data);
    
     if (res.data.length) setactivetab(0);
   
      }catch(error){
      console.error(error);
      }
    }
    cityu();
       fetcatsubcat();
    fetchprevious();
    fetchTestimonial();

    
  },[]);

  let uniquecities=[];
   for(let i=0;i<city.length;i++){
    let exists=false;

    for(let j=0;j<uniquecities.length;j++){
        if(uniquecities[j]==city[i].city){
         exists=true;
         break;
        }
    }
    if(!exists){
        uniquecities.push(city[i].city);
    }
   }


    return(
        <>
             <Header />
             <Marquee/>
       <Helmet>
        <title>Pranati Interior - Kolkata best Interior</title>
        <meta name="description" content="Welcome to Kolkata best interior" />

        <link rel="canonical" href="https://squareandangle.pranatigroup.in/city_base" />

        <meta property="og:title" content="Pranati interior" />
        <meta property="og:description" content="Kolkata best Interior" />
        <meta property="og:image" content="/images/preview.png" />
        <meta property="og:url" content="https://squareandangle.pranatigroup.in/city_base" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pranati interior" />
        <meta name="twitter:description" content="Kolkata best Interior" />
        <meta name="twitter:image" content="/images/preview.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Pranati Interior",
            "url": "https://squareandangle.pranatigroup.in/city_base",
            "description": "Kolkata best Interior",
            "image": "https://squareandangle.pranatigroup.in/images/preview.png",
            "areaServed": "Kolkata",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Kolkata",
              "addressRegion": "West Bengal",
              "addressCountry": "IN"
            }
          })}
        </script>
      </Helmet>
    
    <div className="breadcumb-area black-opacity bg-img-6">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="breadcumb-wrap">
                        <h2>Low Cost Best Interior </h2>
                        <ul>
                            <li>Today we are very happy to give 1200 customers their favorite interior at a low cost. In the future, we will create and show better interiors.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
   <div
  className="about-area3"
  style={{
    padding: "90px 0",
    background: "#fff",
    overflow: "hidden",
  }}
>
  <div
    className="container"
    style={{
      maxWidth: "1200px",
      width: "100%",
      margin: "0 auto",
      padding: "0 20px",
    }}
  >
    {/* MAIN TWO COLUMN ROW */}
    <div className="interior-row">
      
      {/* ================= LEFT SIDE ================= */}
      <div className="interior-content">
        <div
          className="about-active"
          style={{
            padding: "20px 0 40px",
          }}
        >
          <div
            className="about-wrap3"
            style={{
              padding: "10px 0 30px",
            }}
          >
            {/* SMALL TITLE */}
            <span
              style={{
                display: "block",
                color: "#e85d04",
                fontSize: "13px",
                fontWeight: "700",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                marginBottom: "12px",
              }}
            >
              Areas We Serve
            </span>

            
            {/* SUB HEADING */}
            <h3
              style={{
                color: "#444",
                fontSize: "19px",
                lineHeight: "1.5",
                fontWeight: "500",
                margin: "0 0 18px",
              }}
            >
              Professional interior design solutions for homes, offices and
              commercial spaces across Howrah, Hooghly ,Soth 24 Pargans, North 24 Parganas & Kolkata.
            </h3>

            {/* DESCRIPTION */}
            <p
              style={{
                color: "#666",
                fontSize: "15px",
                lineHeight: "1.8",
                margin: "0",
              }}
            >
              Pranati Interior provides complete interior design, renovation
              and decoration services in Howrah, Hooghly and Kolkata. Our team
              helps homeowners and businesses create beautiful, functional and
              comfortable spaces with practical designs and quality
              workmanship. From modern home interiors to office and commercial
              projects, we provide personalized interior solutions based on
              your space, requirements and budget.
            </p>
          </div>

          {/* ================= AREA CARDS ================= */}
          <div className="area-cards">

            {/* HOWRAH */}
            <div className="area-card">
              <h3>Howrah</h3>
              <p>
                Interior design, renovation and decoration services in Howrah.
              </p>
            </div>

            {/* HOOGHLY */}
            <div className="area-card">
              <h3>Hooghly</h3>
              <p>
                Professional interior planning and renovation services in
                Hooghly.
              </p>
            </div>

            {/* KOLKATA */}
            <div className="area-card">
              <h3>Kolkata</h3>
              <p>
                Modern interior design solutions for homes and offices in
                Kolkata.
              </p>
            </div>

            {/* SOUTH 24 PARGANAS */}
            <div className="area-card">
              <h3>South 24 Parganas</h3>
              <p>
                Interior design and renovation services across South 24
                Parganas.
              </p>
            </div>

            {/* NORTH 24 PARGANAS */}
            <div className="area-card">
              <h3>North 24 Parganas</h3>
              <p>
                Interior design and renovation services across North 24
                Parganas.
              </p>
            </div>

          </div>
        </div>
      </div>


      {/* ================= RIGHT SIDE ================= */}
      <div className="interior-image-wrapper">

        <div
          style={{
            position: "relative",
            width: "100%",
          }}
        >

          {/* LARGE MAIN IMAGE */}
          <div className="main-image-box">
            <img
              src="/assets/images/about/low-cost-design.webp"
              alt="Low cost interior design Howrah"
              onError={(e) => {
                e.currentTarget.src =
                  "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1000&q=80";
              }}
            />
          </div>


          {/* SMALL OVERLAPPING IMAGE */}
          <div className="small-image-box">
            <img
              src="/assets/images/low-inetrior.webp"
              alt="Modern interior design Howrah"
              onError={(e) => {
                e.currentTarget.src =
                  "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=600&q=80";
              }}
            />
          </div>


          {/* PRICE CARD */}
          <div className="price-card">
            <div className="price">
              ₹2 Lakhs+
            </div>

            <div className="price-text">
              Starting Interior Price
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>


  {/* ================= RESPONSIVE + DESIGN CSS ================= */}
  <style>
    {`

      /* ========================================
         MAIN TWO COLUMN LAYOUT
      ======================================== */

      .interior-row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 70px;
        align-items: center;
      }


      /* ========================================
         LEFT CONTENT
      ======================================== */

      .interior-content {
        width: 100%;
        min-width: 0;
      }


      /* ========================================
         AREA CARDS
      ======================================== */

      .area-cards {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        margin-top: 10px;
      }

      .area-card {
        padding: 15px;
        background: #f8f8f8;
        border-radius: 5px;
        border-left: 3px solid #e85d04;
        transition: all 0.3s ease;
      }

      .area-card:hover {
        background: #fff;
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
      }

      .area-card h3 {
        color: #222;
        font-size: 17px;
        line-height: 1.3;
        margin: 0 0 6px;
        font-weight: 600;
      }

      .area-card p {
        color: #666;
        font-size: 12px;
        line-height: 1.5;
        margin: 0;
      }


      /* ========================================
         RIGHT IMAGE AREA
      ======================================== */

      .interior-image-wrapper {
        width: 100%;
        min-width: 0;
        position: relative;
        padding: 20px 25px 40px 35px;
      }


      /* ========================================
         MAIN IMAGE
      ======================================== */

      .main-image-box {
        width: 100%;
        height: 520px;
        overflow: hidden;
        border-radius: 8px;
        background: #eee;
      }

      .main-image-box img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: transform 0.5s ease;
      }

      .main-image-box:hover img {
        transform: scale(1.03);
      }


      /* ========================================
         SMALL IMAGE
      ======================================== */

      .small-image-box {
        position: absolute;
        left: 0;
        bottom: 35px;
        width: 220px;
        height: 170px;
        padding: 6px;
        background: #fff;
        border-radius: 6px;
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
        z-index: 2;
      }

      .small-image-box img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        border-radius: 3px;
      }


      /* ========================================
         PRICE CARD
      ======================================== */

      .price-card {
        position: absolute;
        right: 0;
        bottom: 20px;
        background: #222;
        color: #fff;
        padding: 18px 24px;
        border-radius: 5px;
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);
        z-index: 3;
      }

      .price {
        color: #f47b44;
        font-size: 27px;
        font-weight: 700;
        line-height: 1;
        margin-bottom: 7px;
      }

      .price-text {
        font-size: 12px;
        color: #ddd;
        white-space: nowrap;
      }


      /* ========================================
         TABLET
      ======================================== */

      @media (max-width: 991px) {

        .interior-row {
          grid-template-columns: 1fr !important;
          gap: 50px !important;
        }

        .interior-image-wrapper {
          padding: 20px 25px 40px 35px;
        }

        .main-image-box {
          height: 500px;
        }

      }


      /* ========================================
         MOBILE
      ======================================== */

      @media (max-width: 767px) {

        .about-area3 {
          padding: 55px 0 !important;
        }

        .about-area3 .container {
          padding: 0 16px !important;
        }

        .interior-row {
          grid-template-columns: 1fr !important;
          gap: 40px !important;
        }


        /* LEFT CONTENT */

        .about-active {
          padding: 10px 0 20px !important;
        }

        .about-wrap3 {
          padding: 10px 0 20px !important;
        }

        .about-wrap3 h2 {
          font-size: 30px !important;
          line-height: 1.2 !important;
        }

        .about-wrap3 h3 {
          font-size: 17px !important;
        }

        .about-wrap3 p {
          font-size: 14px !important;
          line-height: 1.7 !important;
        }


        /* AREA CARDS */

        .area-cards {
          grid-template-columns: 1fr 1fr !important;
          gap: 10px !important;
        }

        .area-card {
          padding: 13px !important;
        }

        .area-card h3 {
          font-size: 15px !important;
        }

        .area-card p {
          font-size: 11px !important;
        }


        /* IMAGE */

        .interior-image-wrapper {
          padding: 10px 15px 40px 15px !important;
        }

        .main-image-box {
          height: 350px !important;
        }

        .small-image-box {
          left: -5px !important;
          bottom: 20px !important;
          width: 150px !important;
          height: 120px !important;
        }

        .price-card {
          right: -5px !important;
          bottom: 10px !important;
          padding: 14px 17px !important;
        }

        .price {
          font-size: 21px !important;
        }

        .price-text {
          font-size: 10px !important;
        }

      }


      /* ========================================
         SMALL MOBILE
      ======================================== */

      @media (max-width: 480px) {

        .about-wrap3 h2 {
          font-size: 27px !important;
        }

        .about-wrap3 h3 {
          font-size: 16px !important;
        }

        .area-cards {
          grid-template-columns: 1fr !important;
        }

        .main-image-box {
          height: 280px !important;
        }

        .small-image-box {
          width: 125px !important;
          height: 100px !important;
        }

        .price-card {
          padding: 12px 14px !important;
        }

        .price {
          font-size: 19px !important;
        }

        .price-text {
          font-size: 9px !important;
        }

      }

    `}
  </style>
</div>


   
    
    
   <div className="team-area bg-1">
    <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="section-title text-center">
                    <h2>Previous 3 BHK Interior Work</h2>
                    <h3>
                        Take a look at 3 BHK interior designs made in Kolkata
                        and estimate your 3 BHK interior idea
                    </h3>
                </div>
            </div>
        </div>

        <div className="row">
            {previous.map((item, index) => (
                <div
                    className="col-lg-4 col-md-6 col-sm-6 col-12"
                    key={item.id || index}
                >
                    <div className="team-wrap">
                        
                        {/* Large Image */}
                        <div className="team-img">
                            <img
                                className="img-responsive img-related"
                                src={uploadUrl(item.image)}
                                title="3 BHK Interior Design Cost Kolkata | Pranati Interior"
                                alt="3 BHK interior design in Kolkata"
                                style={{
                                    width: "100%",
                                    height: "320px",
                                    objectFit: "cover",
                                    display: "block"
                                }}
                            />
                        </div>

                        <div className="team-content text-center">
                            {/* <h4>{item.title}</h4> */}

                            {/* <a
                                href="https://api.whatsapp.com/send?phone=6289001010&text=Hi%20I%20Need%20More%20Support%20For%20My%203%20BHK%20Interior%20Design%20Cost"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success"
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    marginTop: "10px",
                                    padding: "10px 20px",
                                    borderRadius: "5px"
                                }}
                            >
                                <i className="fa fa-whatsapp"></i>
                                WhatsApp Now
                            </a> */}
                        </div>

                    </div>
                </div>
            ))}
        </div>
    </div>
</div>

    
   
    
   
   
    <Footer/>
    
       <WhatsAppButton />
      <Chat/>
      <Call/>
    
        </>
    )
}

export default CityBase;